import { render } from "./TotalTable.vue?vue&type=template&id=a35ae792&ts=true"
import script from "./TotalTable.vue?vue&type=script&lang=ts"
export * from "./TotalTable.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\iflam\\OneDrive\\নথিসমূহ\\tms-next\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__